/* Menu « Verre » Antistatik (19/10/2026) : ouverture au survol avec délai, au clic et au clavier ; familles ; tiroir téléphone.
   Le HTML est complet sans ce script (liens lisibles par Google) : il ne fait qu'ajouter le comportement.
   22/10 (C7) : les liens vers un autre site s'ouvrent dans un nouvel onglet par leur seul HTML (target="_blank"), sans script.
   L'explication de l'onglet Express est une ligne toujours visible (CSS seul, plus de bulle à gérer). */
(() => {
  const OPEN_DELAY = 120;
  const CLOSE_DELAY = 220;
  const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');

  /* ---------- Menu ordinateur ---------- */
  const nav = document.querySelector('[data-ask-vm]');
  if (nav) {
    const items = Array.from(nav.querySelectorAll('[data-ask-vm-item]'));
    let openItem = null;
    let yOuvert = 0;
    let tOpen = 0;
    let tClose = 0;

    const setOpen = (item, on) => {
      item.classList.toggle('is-open', on);
      item.querySelector('.ask-vm__toggle').setAttribute('aria-expanded', on ? 'true' : 'false');
      if (item.classList.contains('ask-vm__item--panel')) item.querySelector(':scope > .ask-vm__tab')?.setAttribute('aria-expanded', on ? 'true' : 'false');
    };
    const open = (item) => {
      if (openItem && openItem !== item) setOpen(openItem, false);
      setOpen(item, true);
      openItem = item;
      yOuvert = window.scrollY;
    };
    const close = () => {
      if (!openItem) return;
      setOpen(openItem, false);
      openItem = null;
    };
    const visibleLinks = (item) =>
      Array.from(item.querySelectorAll('.ask-vm__panel a')).filter((a) => a.offsetParent !== null);

    items.forEach((item) => {
      const toggle = item.querySelector('.ask-vm__toggle');

      item.addEventListener('mouseenter', () => {
        if (!canHover.matches) return;
        clearTimeout(tClose);
        clearTimeout(tOpen);
        tOpen = setTimeout(() => open(item), openItem ? 0 : OPEN_DELAY);
      });
      item.addEventListener('mouseleave', () => {
        if (!canHover.matches) return;
        clearTimeout(tOpen);
        tClose = setTimeout(() => {
          if (openItem === item) close();
        }, CLOSE_DELAY);
      });
      toggle.addEventListener('click', (e) => {
        e.preventDefault();
        clearTimeout(tOpen);
        if (item.classList.contains('is-open')) close();
        else open(item);
      });
      // Onglet avec panneau (« Nos textiles », « Procédés »…) : le clic sur le mot ouvre le panneau au lieu de changer de page
      // (demande de Quentin du 21/10). Le lien reste dans le HTML pour Google. À la souris, un clic sur un panneau déjà ouvert le laisse ouvert.
      const tab = item.classList.contains('ask-vm__item--panel') ? item.querySelector(':scope > .ask-vm__tab') : null;
      if (tab) {
        tab.setAttribute('aria-expanded', 'false');
        tab.setAttribute('aria-controls', toggle.getAttribute('aria-controls') || '');
        tab.addEventListener('click', (e) => {
          e.preventDefault();
          clearTimeout(tOpen);
          if (!item.classList.contains('is-open')) open(item);
          else if (!canHover.matches) close();
        });
      }
      item.addEventListener('focusout', (e) => {
        if (openItem === item && !item.contains(e.relatedTarget)) close();
      });

      const fams = Array.from(item.querySelectorAll('[data-ask-fam]'));
      fams.forEach((fam) => {
        const pick = () => {
          fams.forEach((f) => f.classList.toggle('is-active', f === fam));
          item.querySelectorAll('.ask-vm__detail').forEach((d) => d.classList.toggle('is-active', d.id === fam.dataset.askFam));
        };
        fam.addEventListener('mouseenter', pick);
        fam.addEventListener('focus', pick);
      });
    });

    nav.addEventListener('keydown', (e) => {
      if (!openItem || (e.key !== 'ArrowDown' && e.key !== 'ArrowUp')) return;
      const links = visibleLinks(openItem);
      if (!links.length) return;
      const toggle = openItem.querySelector('.ask-vm__toggle');
      if (document.activeElement === toggle) {
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          links[0].focus();
        }
        return;
      }
      const i = links.indexOf(document.activeElement);
      if (i < 0) return;
      e.preventDefault();
      if (e.key === 'ArrowUp' && i === 0) toggle.focus();
      else links[e.key === 'ArrowDown' ? Math.min(i + 1, links.length - 1) : i - 1].focus();
    });

    // 22/10 C7 : la bulle d'explication de l'Express est remplacée par une ligne toujours visible (CSS seul) : plus rien à gérer ici.

    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape' || !openItem) return;
      const toggle = openItem.querySelector('.ask-vm__toggle');
      close();
      toggle.focus();
    });
    document.addEventListener('click', (e) => {
      if (openItem && !openItem.contains(e.target)) close();
    });
    // Images des panneaux : chargées en arrière-plan une fois la page prête (pas de trou à la première ouverture)
    const prechargerImages = () => nav.querySelectorAll('.ask-vm__panel img[loading="lazy"]').forEach((img) => { img.loading = 'eager'; });
    if (canHover.matches) {
      const plusTard = () => ('requestIdleCallback' in window ? requestIdleCallback(prechargerImages, { timeout: 4000 }) : setTimeout(prechargerImages, 2500));
      if (document.readyState === 'complete') plusTard();
      else window.addEventListener('load', plusTard, { once: true });
      nav.addEventListener('mouseenter', prechargerImages, { once: true });
    }

    /* E9 (23/10/2026, G4 M4) : un panneau ouvert se ferme dès qu'on fait défiler la page (120 px), ou quand la barre se cache
       ou sort de l'écran. Avant, la barre se cachait à la molette (Dawn pose sa classe après ce test) et le panneau restait
       ouvert, détaché en haut de l'écran, sans barre ni bouton pour le fermer. Le test est refait à l'image suivante. */
    const fermerSiDefile = () => {
      if (!openItem) return;
      const barre = document.querySelector('.section-header');
      const r = barre && barre.getBoundingClientRect();
      if (document.querySelector('.section-header.shopify-section-header-hidden') || (r && r.bottom <= 0) || Math.abs(window.scrollY - yOuvert) > 120) close();
    };
    window.addEventListener(
      'scroll',
      () => {
        fermerSiDefile();
        requestAnimationFrame(fermerSiDefile);
      },
      { passive: true }
    );
  }

  /* ---------- Tiroir téléphone ---------- */
  if (!customElements.get('ask-verre-drawer')) {
    customElements.define(
      'ask-verre-drawer',
      class extends HTMLElement {
        connectedCallback() {
          this.details = this.querySelector('.ask-vd__details');
          this.panel = this.querySelector('.ask-vd__panel');
          this.summary = this.details.querySelector(':scope > summary');
          this.details.addEventListener('toggle', () => this.onToggle());
          this.details.addEventListener('click', (e) => {
            if (e.target === this.details) this.details.open = false;
          });
          this.panel.addEventListener('click', (e) => {
            if (e.target.closest('a')) this.details.open = false;
          });
          this.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && this.details.open) {
              this.details.open = false;
              this.summary.focus();
            }
          });
          window.matchMedia('(min-width: 990px)').addEventListener('change', (m) => {
            if (m.matches) this.details.open = false;
          });
        }

        onToggle() {
          const on = this.details.open;
          if (on) {
            const bar = this.closest('.header');
            const top = bar ? Math.round(bar.getBoundingClientRect().bottom + 8) : 84;
            this.style.setProperty('--ask-vd-top', `${top}px`);
            this.panel.focus({ preventScroll: true });
          }
          document.documentElement.classList.toggle('ask-vd-open', on);
          this.summary.setAttribute('aria-expanded', on ? 'true' : 'false');
        }
      }
    );
  }
})();
